import { render, staticRenderFns } from "./Marketzodiac.vue?vue&type=template&id=06c47806&scoped=true&"
import script from "./Marketzodiac.vue?vue&type=script&lang=js&"
export * from "./Marketzodiac.vue?vue&type=script&lang=js&"
import style0 from "./Marketzodiac.vue?vue&type=style&index=0&id=06c47806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c47806",
  null
  
)

export default component.exports